import "./Profile.css";
import logo from "../images/Black_And_White_Rakia_Design_Studio_Logo-removebg-preview.png";
import profileimage from "../images/mockaroon-YqUeLG7fMr4-unsplash.png";
import { AiFillGithub } from "@react-icons/all-files/ai/AiFillGithub";
import { AiOutlineInstagram } from "@react-icons/all-files/ai/AiOutlineInstagram";
import { AiFillLinkedin } from "@react-icons/all-files/ai/AiFillLinkedin";
import { Link } from "react-scroll";

const Mainprofile = () => {
  return (
    <div
      className="profile-main-div"
      data-aos="fade-right"
      data-aos-offset="50"
      data-aos-delay="500"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div className="profile-inner-content">
        <div className="profile-top-bar">
          <div className="profile-main-name-heading">
            <img className="name-logo" src={logo} alt="logo"></img>
          </div>
          <div className="profile-top-description">
            <div className="profile-top-description-text">frontend web</div>
            <div className="profile-top-description-text">developer</div>
          </div>
        </div>
        <img className="profile-main-image" src={profileimage}></img>
        <h2 className="profile-full-name">suryansh malik</h2>
        <h2 className="profile-full-name">based in new delhi, india</h2>
        <div className="all-right">© 2023 Suryansh. All Rights Reserved</div>
        <div className="profile-social-media-icons">
          <a href="https://github.com/suryansh-malik" target="_blank">
            <AiFillGithub className="icons" />
          </a>

          <a href="https://www.instagram.com/suryansh__malik/"
target="_blank"
          >
            <AiOutlineInstagram className="icons" />
          </a>

          <a
            href="https://www.linkedin.com/in/suryansh-malik-169a2223b/"
            target="_blank"
          >
            <AiFillLinkedin className="icons" />
          </a>
        </div>
        <Link
          to="about"
          spy={true}
          smooth={true}
          offset={0}
          duration={1000}
          className="profile-about-button"
        >
          about me
        </Link>
      </div>
    </div>
  );
};
export default Mainprofile;
